<template>
	<div class="card-item-wrapper p-d-12">
		<div class="card-item">
			<div class="clik"
			     :id="'dropdownMenuLink'+alamat.idalamat"
			     data-toggle="dropdown"
			     aria-haspopup="true"
			     aria-expanded="false">
			</div>
			<div v-if="alamat.judul === '' && alamat.tetap === 0">
				<div class="top-card">
					<div class="f-regular f-16 f-c-black m-t-4" v-if="isSearch"
					     v-html="searchHighlight(alamat.lokasi, search.key)"
					>
					</div>
					<div class="f-regular f-16 f-c-black m-t-4" v-else>
						{{ alamat.lokasi }}
					</div>
					<div class="card-menu-vertical"></div>
				</div>
			</div>
			<div v-else>
				<div class="top-card">
					<div class="f-bold f-16 f-c-black">
						<span class="m-r-4 overflow-wrap-anywhere" v-if="isSearch && alamat.judul !== ''"
						      v-html="searchHighlight(alamat.judul, search.key)"
						></span>
						<span class="m-r-4 overflow-wrap-anywhere" v-else-if="!isSearch && alamat.judul !== ''">{{ alamat.judul }}</span>
						<span class="f-regular f-12 f-c-midgrey alamat-box-label" v-if="alamat.tetap">
						Alamat Utama
					</span>
					</div>
					<div class="card-menu-vertical"></div>
				</div>
				<div class="f-regular f-16 f-c-black m-t-4 overflow-wrap-anywhere" v-if="isSearch"
				     v-html="searchHighlight(alamat.lokasi, search.key)"
				>
				</div>
				<div class="f-regular f-16 f-c-black m-t-4 overflow-wrap-anywhere" v-else>
					{{ alamat.lokasi }}
				</div>
			</div>
			<div class="f-regular f-12 f-c-midgrey"
			     v-if="alamat.latitude !== 0 || alamat.longitude !== 0"
			>
				<i class="fas fa-map-marker f-c-midgrey f-12 m-r-4"></i>Titik lokasi terpasang
			</div>
			<div class="f-regular f-12 f-c-midgrey" v-else>
				Titik lokasi belum terpasang
			</div>

			<div class="clik"
			     :id="'dropdownMenuLink'+alamat.idalamat"
			     :data-toggle="useDropdown ? 'dropdown' : ''"
			     aria-haspopup="true"
			     aria-expanded="false">
			</div>
			<div class="dropdown-menu garis-listkomisi">
				<button class="dropdown-item icon-2" v-if="validateAccess('customerRegular.update')" @click="edit(alamat)">
					<span class="mar-right-10">
						<img src="../../../assets/icons/edit_2.svg">
					</span>
					Ubah
				</button>
				<button class="dropdown-item icon-2" v-if="validateAccess('customerRegular.delete')" @click="deleteAlamat(alamat)">
					<span class="mar-right-10">
						<img src="../../../assets/icons/trash-red.svg">
					</span>
					Hapus
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

export default {
	name: "SOCardCustomerListAlamat",
	props: ["alamat", "idcustomer", "idalamat"],
	computed: {
		...mapGetters("customerModule", {
			alamatTemp: "getAlamatTemp",
			isSearch: "getIsSearchAlamat",
			search: "getSearchAlamat"
		}),
		useDropdown() {
			return (this.validateAccess("customerRegular.update") || this.validateAccess("customerRegular.delete"))
		}
	},
	methods: {
		edit(alamat) {
			let dataAlamat = this.alamatTemp
			dataAlamat.alamat = alamat.lokasi
			dataAlamat.alamat_utama = (alamat.tetap.toString() === "1") ? [alamat.tetap.toString()] : []
			dataAlamat.judul = alamat.judul
			dataAlamat.latitude = alamat.latitude
			dataAlamat.longitude = alamat.longitude
			dataAlamat.idcustomer = this.idcustomer
			dataAlamat.idalamat = this.idalamat

			this.$store.commit("customerModule/setAlamatTemp", dataAlamat)
			this.$router.push("/konsumen/alamat/edit/" + this.idcustomer + "/" + this.idalamat)
		},
		deleteAlamat(alamat) {
			this.$emit("delete", alamat)
		}
	},
}
</script>

<style scoped>
.alamat-box-label {
	padding: 4px;
	background: #EDEDED;
	border-radius: 4px;
}
</style>